import { adminRoutes } from 'modules/admin/routes/constants';

export const settingsRoutes = {
  root: `${adminRoutes.root}/settings`,
};
